import gql from 'graphql-tag';
import { adminCategoryListFragment } from 'graphql/fragments';

const UPDATE_CATEGORY_MUTATION = gql`
  mutation updateCategory($_id: ID!, $modifier: UpdateCategoryInput!) {
    updateCategory(_id: $_id, modifier: $modifier) {
      ...adminCategoryListFragment
    }
  }
  ${adminCategoryListFragment}
`;

export default UPDATE_CATEGORY_MUTATION;
